<template>
  <div class="alert alert-info alert-dismissable" v-if="message">
    <p>{{message}}</p>
  </div>
</template>
<script>
  export default {
    props: ['message']
  }
</script>



// WEBPACK FOOTER //
// Message.vue?2641266e